export default __webpack_public_path__ + "static/media/mali.6ae024de.svg";